import { smsCountMessage } from '@/plugins/vee-validate/messages/sms_count';
import { CounterSMS } from '@/plugins/sms-counter';

export const sms_count = {
  validate: function(value, { max_sms_count }) {
    const { length, per_message } = CounterSMS.count(value);
    return length <= per_message * max_sms_count;
  },

  message: (filed, values) => {
    return smsCountMessage(filed, values);
  },

  params: [{ name: 'max_sms_count' }]
};
